export default __webpack_public_path__ + "static/media/rangers.95a8542e.jpg";